import { render, staticRenderFns } from "./TabelaResumoImportacoesBasesSigr.vue?vue&type=template&id=ad2d9402&"
import script from "./TabelaResumoImportacoesBasesSigr.vue?vue&type=script&lang=js&"
export * from "./TabelaResumoImportacoesBasesSigr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VProgressCircular,VSimpleTable})
